<template>
  <div class="row f-row" style="position: relative">
    <div
      class="justify-content-center vert-align loading-div"
      v-if="!companyParametersReady"
    >
      <div class="col col-5 text-center inh">
        Please wait
        <QSLoading
          :isLoading="!companyParametersReady"
          :size="20"
          :colorTheme="colorTheme"
        />
      </div>
    </div>
    <div class="col col-cx">
      <div class="row f-row" style="position: relative">
        <div class="col col-auto" style="padding: 0 0 0 5px !important;">
          <button
            style="width: 22px; margin: 0!important;"
            class="btn btn-strat-blue"
            v-on:click="onUserFetchExpand"
          >
            <i
              v-if="Analytics['rawData']['toBeFetchedHidden']"
              class="fa fa-angle-double-right"
              style="font-size: 1.2rem"
            ></i>
            <i
              v-else
              class="fa fa-angle-double-left"
              style="font-size: 1.2rem"
            ></i>
          </button>
        </div>
        <!-- Company, Portfolio, Product/Currency -->
        <template v-if="!Analytics['rawData']['toBeFetchedHidden']">
          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 8px!important; padding-left: 5px!important;"
              >Companies:</span
            >
          </div>
          <div class="col col-1 no-dropdown" v-if="companies.length === 0">
            N.A.
          </div>
          <div class="col col-1 no-dropdown" v-else-if="companies.length === 1">
            {{ newSelectedCompanies[0].company_name }}
          </div>
          <div class="col col-1 text-left" v-else>
            <MultiSelect
              v-model="newSelectedCompanies"
              :options="companies"
              :filter="true"
              placeholder="Select Companies"
              class="p-column-filter"
              optionLabel="company_name"
              scrollHeight="400px"
            >
              <template #option="slotProps">
                <div class="p-multiselect-representative-option">
                  <span class="image-text">{{
                    slotProps.option.company_name
                  }}</span>
                </div>
              </template>
            </MultiSelect>
          </div>
          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 8px!important; padding-left: 16px!important;"
              >Portfolios:</span
            >
          </div>
          <div class="col col-1 no-dropdown" v-if="newPortfolios.length === 0">
            N.A.
          </div>
          <div
            class="col col-1 no-dropdown bdr-b-h"
            v-else-if="newPortfolios.length === 1"
          >
            {{ newSelectedPortfolios[0].name }}
          </div>
          <div class="col col-1 text-left" v-else>
            <MultiSelect
              v-model="newSelectedPortfolios"
              :options="newPortfolios"
              :filter="true"
              placeholder="Select Portfolios"
              class="p-column-filter"
              optionLabel="name"
              scrollHeight="400px"
            >
              <template #option="slotProps">
                <div class="p-multiselect-representative-option">
                  <span class="image-text">
                    <template v-if="newSelectedCompanies.length > 1">
                      {{ slotProps.option.companyName }} -
                    </template>
                    {{ slotProps.option.name }}</span
                  >
                </div>
              </template>
            </MultiSelect>
          </div>
          <div
            class="col col-auto txt-label-primary-2"
            style="justify-content: flex-start!important;"
          >
            <span
              style="padding-right: 8px!important; padding-left: 16px!important;"
              >{{
                Analytics["assetType"] === "currency" ? "Currency" : "Product"
              }}:</span
            >
          </div>
          <template v-if="Analytics['assetType'] === 'commodity'">
            <div
              class="col col-2 no-dropdown bdr-b-h"
              v-if="newAssets.length === 0"
            >
              N.A.
            </div>
            <div class="col col-2 text-left" v-else>
              <MultiSelect
                v-model="newSelectedAsset"
                :options="newAssets"
                :filter="true"
                placeholder="Select Assets"
                class="p-column-filter"
                optionLabel="product_name"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{
                      slotProps.option.product_name
                    }}</span>
                  </div>
                </template>
              </MultiSelect>
            </div>
          </template>
          <template v-else>
            <div
              class="col col-2 no-dropdown bdr-b-h"
              v-if="newAssets.length === 0"
            >
              N.A.
            </div>
            <div class="col col-2 text-left" v-else>
              <MultiSelect
                v-model="newSelectedAsset"
                :options="newAssets"
                :filter="true"
                placeholder="Select a Currency"
                class="p-column-filter"
                optionLabel="currency_name"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{
                      slotProps.option.currency_name
                    }}</span>
                  </div>
                </template>
              </MultiSelect>
            </div>
          </template>
        </template>

        <!-- Fetch data -->
        <div
          class="col col-1"
          :class="screenWidth < 1280 ? 'col-2' : 'col-1'"
          v-if="Analytics['rawData']['toBeFetched']"
        >
          <button
            type="button"
            class="btn btn-strat-blue"
            style="margin: 0!important;"
            v-on:click="onUserFetchData"
          >
            <span>Get Information</span>
          </button>
        </div>
        <div class="col col-auto" style="padding-left: 5px !important;" v-else>
          <button
            style="width: 22px; margin: 0!important;"
            class="btn btn-strat-blue"
            v-on:click="onUserFetchData"
          >
            <i class="fa fa-refresh"></i>
          </button>
        </div>

        <!-- Fetch data -->
        <div
          v-if="
            Analytics['assetType'] === 'commodity' &&
              !Analytics['rawData']['toBeFetched'] &&
              Analytics['rawData']['toBeFetchedHidden'] &&
              renderFilters &&
              ![
                'strategies',
                'derivatives',
                'providers',
                'clients',
                'counterparty',
              ].includes(selectedAnalysis)
          "
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important;"
        >
          <label
            class="ml-2"
            v-bind:class="[
              Analytics['userSelections']['includeFutures']
                ? 'btn-checkbox-active'
                : 'btn-checkbox',
            ]"
          >
            <input type="checkbox" v-on:click="onUserShow('includeFutures')" />
            <span>
              <span
                class="inh"
                style="width: 10px!important;"
                v-if="Analytics['userSelections']['includeFutures']"
              >
                &#x2714;
              </span>
              <span class="inh" style="width: 10px!important;;" v-else
                >&#x2022;</span
              >
              <span
                style="padding-left: 5px;"
                :style="{
                  color: Analytics['userSelections']['includeFutures']
                    ? 'var(--textative)'
                    : 'var(--textinactive)',
                }"
                >Futures</span
              >
            </span>
          </label>
        </div>
        <div
          v-if="
            fixing_type === 'ratio' &&
              Analytics['assetType'] === 'commodity' &&
              !Analytics['rawData']['toBeFetched'] &&
              Analytics['rawData']['toBeFetchedHidden'] &&
              renderFilters &&
              ![
                'strategies',
                'derivatives',
                'providers',
                'clients',
                'counterparty',
              ].includes(selectedAnalysis)
          "
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important;"
        >
          <label
            class="ml-2"
            v-bind:class="[
              Analytics['userSelections']['includeRatio']
                ? 'btn-checkbox-active'
                : 'btn-checkbox',
            ]"
          >
            <input type="checkbox" v-on:click="onUserShow('includeRatio')" />
            <span>
              <span
                class="inh"
                style="width: 10px!important;"
                v-if="Analytics['userSelections']['includeRatio']"
              >
                &#x2714;
              </span>
              <span class="inh" style="width: 10px!important;;" v-else
                >&#x2022;</span
              >
              <span
                style="padding-left: 5px;"
                :style="{
                  color: Analytics['userSelections']['includeRatio']
                    ? 'var(--textative)'
                    : 'var(--textinactive)',
                }"
                >Ratio</span
              >
            </span>
          </label>
        </div>
        <div
          v-if="
            (fixing_type === 'basis' || fixing_type === 'premium') &&
              Analytics['assetType'] === 'commodity' &&
              !Analytics['rawData']['toBeFetched'] &&
              Analytics['rawData']['toBeFetchedHidden'] &&
              renderFilters &&
              ![
                'strategies',
                'derivatives',
                'providers',
                'clients',
                'counterparty',
              ].includes(selectedAnalysis)
          "
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important;"
        >
          <label
            class="ml-2"
            v-bind:class="[
              Analytics['userSelections']['includeBasis']
                ? 'btn-checkbox-active'
                : 'btn-checkbox',
            ]"
          >
            <input type="checkbox" v-on:click="onUserShow('includeBasis')" />
            <span>
              <span
                class="inh"
                style="width: 10px!important;"
                v-if="Analytics['userSelections']['includeBasis']"
              >
                &#x2714;
              </span>
              <span class="inh" style="width: 10px!important;;" v-else
                >&#x2022;</span
              >
              <span
                style="padding-left: 5px;"
                :style="{
                  color: Analytics['userSelections']['includeBasis']
                    ? 'var(--textative)'
                    : 'var(--textinactive)',
                }"
                >{{ fixing_type === "basis" ? "Basis" : "Premium" }}</span
              >
            </span>
          </label>
        </div>
        <div
          v-if="
            Analytics['assetType'] === 'commodity' &&
              !Analytics['rawData']['toBeFetched'] &&
              Analytics['rawData']['toBeFetchedHidden'] &&
              renderFilters &&
              ![
                'strategies',
                'derivatives',
                'providers',
                'clients',
                'counterparty',
              ].includes(selectedAnalysis)
          "
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important;"
        >
          <label
            class="ml-2"
            v-bind:class="[
              Analytics['userSelections']['includeOtherCosts']
                ? 'btn-checkbox-active'
                : 'btn-checkbox',
            ]"
          >
            <input
              type="checkbox"
              v-on:click="onUserShow('includeOtherCosts')"
            />
            <span>
              <span
                class="inh"
                style="width: 10px!important;"
                v-if="Analytics['userSelections']['includeOtherCosts']"
              >
                &#x2714;
              </span>
              <span class="inh" style="width: 10px!important;;" v-else
                >&#x2022;</span
              >
              <span
                style="padding-left: 5px;"
                :style="{
                  color: Analytics['userSelections']['includeOtherCosts']
                    ? 'var(--textative)'
                    : 'var(--textinactive)',
                }"
                >Other costs</span
              >
            </span>
          </label>
        </div>
        <div
          v-if="
            !Analytics['rawData']['toBeFetched'] &&
              renderFilters &&
              Analytics['rawData']['toBeFetchedHidden'] &&
              ![
                'strategies',
                'derivatives',
                'providers',
                'clients',
                'counterparty',
              ].includes(selectedAnalysis)
          "
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important;"
        >
          <span
            style="padding-right: 8px!important; padding-left: 16px!important;"
            >Filter data:</span
          >
          <div class="inh" v-bind:class="[showFilters ? 'active' : '']">
            <button
              style="width: 22px; margin: 0!important;"
              class="btn btn-strat-blue"
              v-on:click="onUserShowFilters"
            >
              <i class="fa fa-filter"></i>
            </button>
          </div>
        </div>

        <div
          v-if="
            !Analytics['rawData']['toBeFetched'] &&
              Analytics['rawData']['toBeFetchedHidden'] &&
              renderFilters &&
              Analytics['userSelections']['xZoom'].length > 0
          "
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important;"
        >
          <span
            style="padding-right: 4px!important; padding-left: 16px!important;"
            >Range:</span
          ><button
            :disabled="isZoomDisabled"
            class="btn detailView"
            v-on:click="onUserZoom(1)"
          >
            <i class="fa fa-chevron-left"></i>
          </button>
          <button class="btn detailView" v-on:click="onUserZoom(2)">
            <i class="fa fa-chevron-right"></i>
          </button>
          <span
            style="padding-right: 1px!important; padding-left: 4px!important; width: 160px;"
            >{{ chartDateRange }}</span
          ><button class="btn detailView" v-on:click="onUserZoom(3)">
            <i class="fa fa-chevron-left"></i>
          </button>
          <button
            :disabled="
              Analytics['userSelections']['xZoom'][1] ===
                Analytics['rawData']['nestedData'].length
            "
            class="btn detailView"
            v-on:click="onUserZoom(4)"
          >
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>

        <div
          v-if="
            !Analytics['rawData']['toBeFetched'] &&
              Analytics['rawData']['toBeFetchedHidden'] &&
              renderFilters &&
              Analytics['userSelections']['xZoom'].length > 0
          "
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important;"
        >
          <span style="padding-right: 3px; padding-left: 9px!important;"
            >Year:</span
          >
        </div>
        <div
          v-if="
            !Analytics['rawData']['toBeFetched'] &&
              Analytics['rawData']['toBeFetchedHidden'] &&
              renderFilters &&
              Analytics['userSelections']['xZoom'].length > 0
          "
          class="txt-label-primary-2"
          style="width: 45px!important; justify-content: flex-start!important;"
        >
          <Calendar
            v-model="yearVal"
            dateFormat="yy"
            placeholder="select"
            view="year"
            :minDate="minYearDate"
            :maxDate="maxYearDate"
          />
        </div>
        <div
          v-if="
            !Analytics['rawData']['toBeFetched'] &&
              renderFilters &&
              Analytics['rawData']['toBeFetchedHidden'] &&
              ![
                'strategies',
                'derivatives',
                'providers',
                'clients',
                'counterparty',
              ].includes(selectedAnalysis)
          "
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important;"
        >
          <span style="padding-right: 3px; padding-left: 9px!important;"
            >Market ref.:</span
          >
        </div>
        <div
          class="col col-auto"
          v-if="
            !Analytics['rawData']['toBeFetched'] &&
              renderFilters &&
              Analytics['rawData']['toBeFetchedHidden']
          "
        >
          <BucketSelector
            :blue="true"
            :includeTitle="false"
            :isMarket="true"
            :pickedDateInterval="Analytics['userSelections']['mktRef']"
            @eventOnChangeInterval="onMktRefChange"
          />
        </div>
      </div>
    </div>

    <div
      class="col col-auto"
      v-if="
        !Analytics['rawData']['toBeFetched'] &&
          (renderFilters || isManagement) &&
          Analytics['rawData']['toBeFetchedHidden']
      "
    >
      <div class="row f-row">
        <div
          v-if="isManagement"
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important;"
        >
          <span style="padding-left: 8px!important;">Select unit:</span>
        </div>
        <div
          v-if="isManagement"
          class="col col-auto txt-label-primary-2"
          style="padding-right: 8px!important; padding-left: 8px!important;"
        >
          <HoverMultiSelection
            :btnWidth="'6rem'"
            :options="availableUnits"
            :selected="selectedUnit"
            @eventOnChangeOption="(opt) => onUserSelectUnit(opt.value)"
          />
        </div>
        <div
          v-if="isManagement"
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important;"
        >
          <span style="padding-left: 8px!important;">Select columns:</span>
        </div>
        <div
          v-if="isManagement"
          class="col txt-label-primary-2"
          style="width: 12rem!important; padding-right: 8px!important; padding-left: 8px!important;"
        >
          <MultiSelect
            v-model="newManagementSelectedCol"
            :options="managementAvailableCol"
            :filter="true"
            placeholder="Select Columns"
            class="p-column-filter"
            scrollHeight="400px"
          >
            <template #option="slotProps">
              <div class="p-multiselect-representative-option">
                <span class="image-text">{{
                  columnsById[slotProps.option]
                }}</span>
              </div>
            </template>
            <template #value="slotProps">
              <div class="p-multiselect-label-container">
                <span
                  v-for="(val, index) in slotProps.value"
                  :key="index"
                  class="p-multiselect-label-item"
                >
                  {{ columnsById[val] }}
                  <span v-if="index < slotProps.value.length - 1">, </span>
                </span>
              </div>
            </template>
          </MultiSelect>
        </div>
        <div
          class="col col-auto txt-label-primary-2 bdr-l"
          style="justify-content: flex-start!important;"
        >
          <span style="padding: 0 8px 0 8px!important;"
            >{{ spotLabel }}:
            <i
              v-show="Analytics['assetType'] === 'commodity'"
              class="fa fa-question-circle txt-label-primary-2"
              style="display: inline; font-size: 1.3rem!important;"
              @mouseover="onHoverHelp(true)"
              @mouseleave="onHoverHelp(false)"
            ></i
          ></span>
        </div>
        <div
          class="col col-auto txt-label-primary-2"
          v-if="Analytics['loading']['spot']"
        >
          <span style="padding: 1px;">
            <QSLoading
              :isLoading="Analytics['loading']['spot']"
              :size="20"
              :colorTheme="colorTheme"
            />
          </span>
        </div>
        <div class="col col-auto">
          <InputNumber
            style="height: 28px!important; padding-right: 2px; width: 8rem!important;"
            :fontSize="'1.3rem'"
            :tableFormat="false"
            :value="+newSpot"
            @input="(val) => onUserSpotChange(val)"
          />
        </div>
        <div class="col col-auto txt-label-primary-2">
          <button
            style="width: 22px; margin: 0!important;"
            class="btn btn-strat-blue"
            v-on:click="onUserFetchData"
          >
            <i class="fa fa-refresh"></i>
          </button>
        </div>
        <div
          v-if="!isManagement"
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important; padding-right: 12px!important;"
        >
          <span
            style="padding-right: 8px!important; padding-left: 8px!important;"
            >Resize charts:</span
          >
          <div class="inh">
            <button
              class="inh"
              style="font-size: 1.3rem"
              @click="onUserRestoreSizes"
            >
              <i class="fa fa-arrows-alt" title="Restore chart sizes"></i>
            </button>
          </div>
        </div>
        <div
          v-if="isManagement"
          class="col col-auto txt-label-primary-2"
          style="justify-content: flex-start!important;"
        >
          <span style="padding: 0 8px 0 8px!important;">Download:</span>
          <button
            @click="download"
            type="submit"
            class="btn-up-dn-load txt-label-primary"
            style="padding-right: 16px!important;"
          >
            <i class="fa fa-download" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createExcelCommManagement } from "../../_core/data/createExcel";
import {
  darkBackground,
  grayLightBackground,
  textactive2,
} from "@/_core/_helpers/_parametric_tools";
import { dateRangeToString } from "@/_core/_helpers/_helpers";
import { defaultAnalytics } from "@/_core/data/Analytics/AnalyticsHelpers.js";
import { select, timeFormat } from "d3";
import BucketSelector from "@/components/intervals/AnalyticsInterval.vue";
import Calendar from "primevue/calendar";
import HoverMultiSelection from "@/components/buttons/HoverMultiSelection.vue";
import InputNumber from "@/components/InputNumber.vue";
import MultiSelect from "primevue/multiselect";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "CompanyPortProdSelector",
  components: {
    QSLoading,
    BucketSelector,
    Calendar,
    HoverMultiSelection,
    InputNumber,
    MultiSelect,
  },
  props: {
    Analytics: {
      required: true,
      default: defaultAnalytics(),
    },
    companies: { required: true, default: [{ id: 0, company_name: "N.A." }] },
    colorTheme: { required: false, type: Boolean, default: true },
    companyParametersReady: { required: false, type: Boolean, default: true },
    isManagement: { required: false, type: Boolean, default: false },
    fixing_type: { required: false, type: String, default: "ratio" },
    loadingAll: { required: true, type: Boolean, default: false },
    managementAvailableCol: { required: false, default: () => [] },
    managementSelectedCol: { required: false, default: () => [] },
    renderFilters: { required: false, type: Boolean, default: false },
    selectedTable: { required: false, default: "strategies" },
    selectedUnit: { required: false, default: "contracts" },
    showFilters: { required: false, type: Boolean, default: false },
    screenWidth: { required: false, type: Number, default: 1280 },
    dataSelectedTable: { required: false, default: () => [] },
  },
  data() {
    return {
      availableUnits: [
        { label: "Contracts", value: "contracts" },
        { label: "Product Qty", value: "product" },
        { label: "Futures Qty", value: "futures" },
      ],
      columnsById: {},
      tooltip: null,
    };
  },
  computed: {
    spotLabel() {
      const assetType = this.Analytics?.assetType;
      if (assetType !== "commodity") {
        return "Spot:";
      }
      const underlying = this.Analytics?.userSelections?.underlying;
      const selectedContract = Array.isArray(underlying)
        ? underlying[0]?.selected_contract
        : null;
      return selectedContract !== undefined && selectedContract !== null
        ? `Spot (c${selectedContract}):`
        : "Spot:";
    },
    minYearDate() {
      const range = this.Analytics?.rawData?.years?.range;
      if (!Array.isArray(range) || typeof range[0] !== "number") {
        return null;
      }
      return new Date(range[0], 0, 1);
    },
    maxYearDate() {
      const range = this.Analytics?.rawData?.years?.range;
      if (!Array.isArray(range) || typeof range[1] !== "number") {
        return null;
      }
      return new Date(range[1], 0, 1);
    },
    isZoomDisabled() {
      const xZoom = this.Analytics?.userSelections?.xZoom;
      if (!Array.isArray(xZoom) || xZoom.length === 0) {
        return true;
      }
      return xZoom[0] === 0;
    },
    newManagementSelectedCol: {
      get: function() {
        return this.managementSelectedCol;
      },
      set: function(newValue) {
        this.$emit("eventOnUserColumns", newValue);
      },
    },
    newFinalDate: {
      get: function() {
        return this.Analytics["valuation"]["finalDate"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserFinalDate", newValue);
        this.setValuationData();
      },
    },
    selectedAnalysis() {
      return this.Analytics["userSelections"]["selectedAnalysis"];
    },
    newSpot() {
      return this.Analytics["rawData"].spot;
    },
    chartDateRange() {
      if (this.Analytics["rawData"]["zoomedData"].length === 0) {
        return timeFormat("%b %d, %Y")(new Date());
      } else {
        let len = this.Analytics["rawData"]["zoomedData"].length - 1;
        return dateRangeToString(
          this.Analytics["rawData"]["zoomedData"][0].date,
          this.Analytics["rawData"]["zoomedData"][len].date,
          true,
          "\u2192",
        );
      }
    },
    newSelectedCompanies: {
      get: function() {
        return this.Analytics["userSelections"]["selectedCompanies"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserCompany", newValue);
      },
    },
    newPortfolios() {
      return this.Analytics["userSelections"]["portfolios"];
    },
    newSelectedPortfolios: {
      get: function() {
        return this.Analytics["userSelections"]["selectedPortfolios"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserPortfolio", newValue);
      },
    },
    newAssets() {
      return this.Analytics["userSelections"]["assets"];
    },
    newSelectedAsset: {
      get: function() {
        return this.Analytics["userSelections"]["selectedAsset"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserAsset", newValue);
      },
    },
    yearVal: {
      get: function() {
        return this.Analytics["userSelections"]["year"] == null
          ? null
          : new Date(this.Analytics["userSelections"]["year"], 1, 1);
      },
      set: function(yearNum) {
        this.$emit("eventOnUserYear", yearNum.getFullYear());
      },
    },
  },
  created() {
    this.createColumnsById();
  },
  mounted() {
    this.tooltip = select("#whole-page-div")
      .append("div")
      .style("opacity", 0)
      .style("margin", 0)
      .style("padding", "1px")
      .style("text-align", "center")
      .style("background", darkBackground(this.colorTheme))
      .style("border", grayLightBackground(this.colorTheme))
      .style("color", textactive2(this.colorTheme))
      .attr("class", "tooltip")
      .style("font-size", "0.8rem")
      .style("width", "350px")
      .html("");
  },
  watch: {
    "Analytics.managementFields": {
      handler() {
        this.createColumnsById();
      },
      deep: true,
    },
    colorTheme() {
      this.tooltip
        .style("background", darkBackground(this.colorTheme))
        .style("border", grayLightBackground(this.colorTheme))
        .style("color", textactive2(this.colorTheme));
    },
  },
  methods: {
    createColumnsById() {
      let columnsById = {};
      let availableColumns = this.Analytics.managementFields;
      if (availableColumns == null) {
        availableColumns = [
          {
            id: 0,
            dataType: "",
            field: "contract_month_year",
            header: "Contract",
            styles: { "max-width": "5rem" },
          },
        ];
      }
      availableColumns.forEach(function(d) {
        columnsById[d.field] = d.header;
      });
      this.columnsById = columnsById;
    },
    download() {
      const nameCompany = this.newSelectedCompanies[0].company_name;

      if (this.dataSelectedTable && this.dataSelectedTable.length > 0) {
        createExcelCommManagement(
          this.Analytics,
          `management_${this.selectedTable}_`,
          nameCompany,
          this.dataSelectedTable,
          `comm_${this.selectedTable}`,
        );
      }
    },
    onUserSelectUnit(val) {
      this.$emit("eventOnUserSelectUnit", val);
    },
    onUserSpotChange(val) {
      this.$emit("eventOnUserSpotChange", val);
    },
    onUserFetchData() {
      this.$emit("eventOnUserFetchData");
    },
    onUserShowFilters() {
      this.$emit("eventOnUserShowFilters", !this.showFilters);
    },
    onUserRestoreSizes() {
      this.$emit("eventOnUserRestoreSizes");
    },
    onMktRefChange(val) {
      this.$emit("eventOnMktRefChange", val);
    },
    onUserShow(str) {
      this.$emit("eventOnUserShow", str);
    },
    onUserZoom(num) {
      this.$emit("eventOnUserZoom", num);
    },
    onUserFetchExpand() {
      this.$emit("eventOnUserFetchExpand");
    },
    onHoverHelp(val) {
      if (val) {
        this.tooltip
          .style("opacity", 1)
          .style("left", this.screenWidth / 2 - 175 + "px")
          .style("top", "120px")
          .html(this.Analytics["userSelections"]["underlying"][0].text);
      } else {
        this.tooltip
          .style("right", "-1000000px")
          .style("top", "0px")
          .style("opacity", 0)
          .html("");
      }
    },
  },
};
</script>

<style scoped></style>
